// Curated Chicago/community/workforce photography for COD platform
// All Unsplash with permissive license, no purple/violet gradients, no generic startup imagery
export const IMG = {
  // Hero & city
  chicagoSkyline: "https://images.unsplash.com/photo-1477414348463-c0eb7f1359b6?w=1600&q=80&auto=format&fit=crop",
  chicagoStreet: "https://images.unsplash.com/photo-1494522855154-9297ac14b55f?w=1600&q=80&auto=format&fit=crop",
  chicagoCta: "https://images.unsplash.com/photo-1564507004663-b6dfb3c824d5?w=1200&q=80&auto=format&fit=crop",
  // People & community
  heroPeople: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1600&q=80&auto=format&fit=crop",
  careerCoaching: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=1200&q=80&auto=format&fit=crop",
  community: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=80&auto=format&fit=crop",
  family: "https://images.unsplash.com/photo-1609220136736-443140cffec6?w=1200&q=80&auto=format&fit=crop",
  interview: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=1200&q=80&auto=format&fit=crop",
  // Sectors
  healthcare: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80&auto=format&fit=crop",
  cna: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=1200&q=80&auto=format&fit=crop",
  trucking: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=1200&q=80&auto=format&fit=crop",
  tech: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=1200&q=80&auto=format&fit=crop",
  construction: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1200&q=80&auto=format&fit=crop",
  security: "https://images.unsplash.com/photo-1582139329536-e7284fece509?w=1200&q=80&auto=format&fit=crop",
  legal: "https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=1200&q=80&auto=format&fit=crop",
  housing: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&q=80&auto=format&fit=crop",
  office: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=1200&q=80&auto=format&fit=crop",
  training: "https://images.unsplash.com/photo-1552581234-26160f608093?w=1200&q=80&auto=format&fit=crop",
};

export const categoryImage = (cat) => ({
  healthcare: IMG.cna,
  transportation: IMG.trucking,
  technology: IMG.tech,
  trades: IMG.construction,
  legal_support: IMG.legal,
  housing: IMG.housing,
  security: IMG.security,
}[cat] || IMG.training);
